import { Observable } from 'rxjs/Observable';
import { Collections } from '../collections.model';

export class ObjectObservable<K extends keyof Collections> extends Observable<
  Collections[K]
> {
  constructor(source: Observable<any>) {
    super();
    this.source = source;
  }

  set(value: any): Observable<void> {
    return Observable.of(undefined);
  }

  update(value: Object): Observable<void> {
    return Observable.of(undefined);
  }

  remove(): Observable<void> {
    return Observable.of(undefined);
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/object-observable.ts